import {BaseField} from 'landing.ui.field.basefield';
import {Cache, Dom, Tag} from 'main.core';
import {Loc} from 'landing.loc';

import './css/style.css';

/**
 * @memberOf BX.Landing.UI.Field
 */
export class UseCaseField extends BaseField
{
	constructor(options = {})
	{
		super(options);
		this.setEventNamespace('BX.Landing.UI.Field.UseCaseField');
		Dom.addClass(this.layout, 'landing-ui-field-use-case');
		this.setTitle(Loc.getMessage('LANDING_USE_CASE_FIELD_TITLE'));

		this.cache = new Cache.MemoryCache();
		this.onLinkClick = this.onLinkClick.bind(this);

		Dom.replace(this.layout, this.getLayout());
		this.layout = this.getLayout();
	}

	getLayout(): HTMLDivElement
	{
		return this.cache.remember('layout', () => {
			return Tag.render`
				<div class="landing-ui-field-use-case-layout">
					<div class="landing-ui-field-use-case-left">
						${this.getIcon()}
					</div>
					<div class="landing-ui-field-use-case-right">
						${this.header}
						${this.getLink()}
					</div>
				</div>
			`;
		});
	}

	getIcon(): HTMLSpanElement
	{
		return this.cache.remember('icon', () => {
			return Tag.render`<span class="landing-ui-field-use-case-icon landing-ui-field-use-case-icon-default"></span>`;
		});
	}

	setIcon(icon: string)
	{
		Dom.style(this.getIcon(), 'background-image', `url(${icon})`);
	}

	getLink(): HTMLSpanElement
	{
		return this.cache.remember('link', () => {
			return Tag.render`
				<div class="landing-ui-field-use-case-link" onclick="${this.onLinkClick}">
					${Loc.getMessage('LANDING_USE_CASE_DEFAULT_CASE_TITLE')}
				</div>
			`;
		});
	}

	setLinkText(text: string)
	{
		this.getLink().textContent = text;
	}

	onLinkClick(event: MouseEvent)
	{
		event.preventDefault();

		this.emit('onClick');
	}
}